<!-- お知らせ詳細 -->
<template>
  <div class="crpg-o-news-detail">
    <CMS contents_type="news" view_type="detail" @completeCMS="loadingHide" />
  </div>
</template>

<script>
import CMS from "@/components/CMS.vue";

export default {
  name: "CrpgOrganismsNewsDetail",
  components: {
    CMS,
  },
  methods: {
    loadingHide() {
      this.$store.dispatch("loading/hide", 10);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/organisms/news/detail.scss";
</style>
